import * as type from './constant';

export const getMemberClass = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getMemberClassSuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getMemberClassError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addMemberClass = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addMemberClassSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateMemberClass = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateMemberClassSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteMemberClass = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteMemberClassSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationMemberClassError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
